export default {
  methods: {
    selectRange(range, fromCreated = false) {
      switch (range.valor) {
        case 'ultimas4semanas':
          this.rangeFrom = this.$moment().subtract(28, 'days')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'esteMes':
          this.rangeFrom = this.$moment().startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'esteMesConAnterior':
          this.rangeFrom = this.$moment().subtract(2, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimos3meses':
          this.rangeFrom = this.$moment().subtract(3, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimos6meses':
          this.rangeFrom = this.$moment().subtract(6, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimos9meses':
          this.rangeFrom = this.$moment().subtract(9, 'month').startOf('month')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimos12meses':
          // eGestion exige init_date < 1 año antes de end_date, sumamos 1 dia de margen
          this.rangeFrom = this.$moment().subtract(1, 'year').add(1, 'day')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimoAnio':
          this.rangeFrom = this.$moment().subtract(1, 'year').startOf('year')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        case 'ultimos2Anios':
          this.rangeFrom = this.$moment().subtract(2, 'year').startOf('year')
            .format('YYYY-MM-DD');
          this.rangeUntil = this.$moment().subtract(0, 'days')
            .format('YYYY-MM-DD');
          break;
        default:
          // this.rangeFrom = this.$moment().subtract(6, 'month').startOf('month')
          //   .format('YYYY-MM-DD');
          // this.rangeUntil = this.$moment().subtract(0, 'days')
          //   .format('YYYY-MM-DD');
          break;
      }
      this.rangeSelected = range;
      if (!fromCreated) {
        this.changeFilters(this.currentFilters);
      }
    }
  }
};
